// The small blue text links of the evidence pages, on a Button or a Link: "Change", "Edit details", "Storefront settings".
export const textLinkSx = { minWidth: 0, p: 0, fontSize: 12, fontWeight: 600, lineHeight: 1.5, letterSpacing: "normal", textTransform: "none" } as const;
